import React, { Component } from 'react';
import LanguageUtil from '../../util/LanguageUtil';
import Icon from '../../icons/Icon';
import ComponentName from '../../constant/ComponentName';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../RoleHelper';
import { SidebarMenuItemProps } from './SidebarMenuItem';
import SidebarMenuItemContainer from './SidebarMenuItemContainer';
import EnvironmentUtil from '../../util/EnvironmentUtil';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';

class OrchestrationMenu extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private menu: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' }),
      path: 'transaction',
      field: 'Transaction',
      icon: <Icon icon={'sidebar-channel'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.TRANSACTION,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.store', defaultMessage: 'Store' }),
      path: 'stream',
      field: 'Stream',
      icon: <Icon icon={'sidebar-store'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.STREAM,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.list', defaultMessage: 'List' }),
      path: 'list',
      field: 'List',
      icon: <Icon icon={'sidebar-list'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.LIST,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.enrichment', defaultMessage: 'Enrichment' }),
      path: 'enrichment',
      field: 'Enrichment',
      icon: <Icon icon={'sidebar-enrichment'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.ENRICHMENT,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.rule', defaultMessage: 'Rule' }),
      path: 'rule',
      field: 'Rule',
      icon: <Icon icon={'sidebar-rule'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.RULE,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.connection', defaultMessage: 'Connection' }),
      path: 'connection',
      field: 'Connection',
      icon: <Icon icon={'sidebar-connection'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.CONNECTION,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.struct', defaultMessage: 'Struct' }),
      path: 'struct',
      field: 'Struct',
      icon: <Icon icon={'sidebar-struct'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.STRUCT,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.mlops', defaultMessage: 'MLOps' }),
      path: 'ai-model',
      field: 'Ai-Model',
      icon: <Icon icon={'sidebar-ai'} className={'text-f-black-2'} size={16} />,
      children: [],
      component: ComponentName.AI_MODEL,
      visible: this.environmentUtil.getAiModel(),
    },
    {
      name: LanguageUtil.get({ id: 'common.label.tracker', defaultMessage: 'Tracker' }),
      path: 'tracker',
      field: 'Tracker',
      icon: <Icon icon={'sidebar-tracker'} className={'text-f-black-2'} size={16} />,
      children: [],
      component: ComponentName.TRACKER,
      visible: this.environmentUtil.getTracker(),
    },
  ];

  public render() {
    const { collapsed, router, goPage } = this.props;
    const pathName = router.location.pathname.split('/')[1];
    const filteredMenu = this.menu.filter((m) => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));

    if (filteredMenu.length == 0) return null;

    return (
      <SidebarMenuItemContainer items={filteredMenu} goPage={goPage} pathName={pathName} collapsed={collapsed} title={LanguageUtil.get({ id: 'common.label.orchestration', defaultMessage: 'ORCHESTRATION' })} collapsedTitle={'O'} />
    );
  }
}

interface Props extends ReduxProps, FormicaProps {
  goPage(m: SidebarMenuItemProps): void;
}

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
  page: state.page,
  component: state.component,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(OrchestrationMenu));
